export const exchangeOverrides = `
  --anchor-color: var(--anchor-color-exchange);
  --body-bg-color: var(--body-bg-color-exchange);
  --header-bg-golor: var(--header-bg-golor-exchange);
  --header-color: var(--header-color-exchange);
  --footer-notice-color: var(--footer-notice-color-exchange);
  --footer-icons-color var(--footer-icons-color-exchange);
  --odd-cell-bg-color: var(--odd-cell-bg-color-exchange);
  --odd-cell-color: var(--odd-cell-color-exchange);
  --odd-cell-bg-color-highlighted: var(--odd-cell-bg-color-highlighted-exchange);
  --odd-cell-color-highlighted: var(--odd-cell-color-highlighted-exchange);
`;
